import type { CreatePriceRequest } from '@domains/subscription/priv/Billables/api/api'
import { type QueryClient, useMutation, useQuery } from '@tanstack/react-query'
import { createBillableTemplatePrice, hasTemplateAnchoredToSignupPrice } from './endpoints'

const QueryKeys = {
  CreateBillableTemplatePrice: (billableId: string, templateId: string) => ['CreateBillableTemplatePrice', billableId, templateId] as const,
  HasTemplateAnchoredToSignupPrice: (templateId: string | undefined) => ['HasTemplateAnchoredToSignupPrice', templateId] as const,
}

export const useCreateBillableTemplatePrice = (billableId: string, templateId: string) => {
  return useMutation({
    mutationKey: QueryKeys.CreateBillableTemplatePrice(billableId, templateId),
    mutationFn: (price: CreatePriceRequest) => createBillableTemplatePrice(billableId, templateId, price),
  })
}

export const useHasTemplateAnchoredToSignupPrice = (templateId: string | undefined) => {
  return useQuery({
    queryKey: QueryKeys.HasTemplateAnchoredToSignupPrice(templateId as string),
    queryFn: () => hasTemplateAnchoredToSignupPrice(templateId as string),
    enabled: !!templateId,
  })
}

export const invalidateHasTemplateAnchoredToSignupPrice = ({
  queryClient,
  templateId,
}: {
  queryClient: QueryClient
  templateId: string | undefined
}) => {
  queryClient.invalidateQueries(QueryKeys.HasTemplateAnchoredToSignupPrice(templateId))
}
